"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");

var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = require("@sentry/react");

var _makeErrorService = _interopRequireDefault(require("./makeErrorService"));

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty2(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context2, _context3; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(source), !0)).call(_context2, function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context3 = ownKeys(Object(source))).call(_context3, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

var errorService = _objectSpread(_objectSpread({}, (0, _makeErrorService["default"])({
  sentryInit: _react.init,
  configureScope: _react.configureScope,
  captureException: _react.captureException,
  lastEventId: _react.lastEventId,
  enableBrowserTracing: true,
  sentryClientOptions: {
    SentryClient: _react.BrowserClient,
    SentryHub: _react.Hub,
    sentryMakeMain: _react.makeMain,
    // Dedupe and InboundFilters are enabled by default and drop events for the client
    // Related Issue - https://github.com/getsentry/sentry-javascript/issues/6165
    defaultIntegrations: (0, _filter["default"])(_react.defaultIntegrations).call(_react.defaultIntegrations, function (integration) {
      var _context;

      return !(0, _includes["default"])(_context = ['Dedupe', 'InboundFilters']).call(_context, integration.name);
    }),
    defaultStackParser: _react.defaultStackParser,
    makeFetchTransport: _react.makeFetchTransport
  }
})), {}, {
  sentryMakeMain: _react.makeMain,
  reactRouterV5Instrumentation: _react.reactRouterV5Instrumentation,
  reactRouterV6Instrumentation: _react.reactRouterV6Instrumentation,
  withSentryRouting: _react.withSentryRouting,
  withSentryReactRouterV6Routing: _react.withSentryReactRouterV6Routing,
  showReportDialog: _react.showReportDialog
});

var _default = errorService;
exports["default"] = _default;